import React from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { messages } from '@atlaskit/editor-common/lists';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { MoreItemsIcon, ToolbarDropdownMenu } from '@atlaskit/editor-toolbar';
import { useIndentationState } from '../utils/hooks';
export var ListsIndentationMenu = function ListsIndentationMenu(_ref) {
  var children = _ref.children,
    api = _ref.api,
    allowHeadingAndParagraphIndentation = _ref.allowHeadingAndParagraphIndentation;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useEditorToolbar = useEditorToolbar(),
    editorView = _useEditorToolbar.editorView;
  var indentationState = useIndentationState({
    api: api,
    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
    state: editorView === null || editorView === void 0 ? void 0 : editorView.state
  });
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['list'], function (states) {
      var _states$listState, _states$listState2;
      return {
        bulletListDisabled: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.bulletListDisabled,
        orderedListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.orderedListDisabled
      };
    }),
    bulletListDisabled = _useSharedPluginState.bulletListDisabled,
    orderedListDisabled = _useSharedPluginState.orderedListDisabled;
  var allItemsDisabled = bulletListDisabled && orderedListDisabled && (indentationState === null || indentationState === void 0 ? void 0 : indentationState.indentDisabled) && (indentationState === null || indentationState === void 0 ? void 0 : indentationState.outdentDisabled);
  return /*#__PURE__*/React.createElement(ToolbarDropdownMenu, {
    iconBefore: /*#__PURE__*/React.createElement(MoreItemsIcon, {
      label: formatMessage(messages.lists)
    }),
    isDisabled: allItemsDisabled,
    testId: "editor-toolbar__lists-and-indentation-menu"
  }, children);
};